import React from "react";
import Helmet from "react-helmet"

import { introBannerData } from '../data/programmes/intro-banner';
import { introData } from '../data/programmes/intro';
import { partnersData } from '../data/programmes/partners';
import { reportsData } from '../data/programmes/reports';
// import SectorUpdates from '../components/organisms/sector-updates/sector-updates'

import BreadCrumb from '../components/atoms/bread-crumb/breadcrumb';
import IntroBanner from '../components/molecules/intro-banner/intro-banner';
import IntroCard from '../components/molecules/intro-card/intro-card';
import HighlightCarousel from '../components/organisms/highlight-carousel/highlight-carousel';
import Reports from '../components/organisms/reports/reports';

import SectorUpdates from '../components/organisms/sector-updates/sector-updates';


class Programmes extends React.Component {

	render() {
		const dtm_deviceCheck = /Mobile/i.test(navigator.userAgent) ? "Mobile" : "Desktop";
		const dataLayer = {
			formName: "",
			formStatus: "",
			formisSubmitted: false,
			deviceType: dtm_deviceCheck,
			siteBusinessUnit: "Tutuwa",
			siteErrorCode: "",
			siteLanguage: "English",
			siteCountry: "South Africa",
			websiteName: "Tutuwa Foundation",
			websiteNameCode: "TT",
			pageCategory: "Our Programmes",
			pageName: "Our Programmes",					
			pageSubSection1: "Our Programmes",
			pageSubSection2: "",
			pageSubSection3: "",
			pageSubSection4: ""
		};

		return (
			<div className="programmes">
				<Helmet>
					<title>Standard Bank Tutuwa Community Foundation: Our Programmes</title>
					<meta name="title" content="Standard Bank Tutuwa Community Foundation: Our Programmes"/>
					<meta name="description" content="We fund and invest in initiatives specially chosen to have maximum input in alleviating poverty in South Africa."/>
					<meta name="keywords" content="Standard bank; tutuwa foundation; poverty alleviation; poverty alleviation initiatives; about tutuwa community foundation; non-profit organisations; social impact; non-profit organisations; social impact organisations; profit and non profit organisation"/>
					<meta name="robots" content="index, follow"/>
					<meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
					<meta name="language" content="English"/>
					<script type="text/javascript" language="javascript">{`
						var dataLayer = ${JSON.stringify(dataLayer)};
					`}</script>
					<script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-e88652abdf04.min.js" async></script> 
				</Helmet>

				<IntroBanner
					title={introBannerData.title}
					description={introBannerData.description}
					button={introBannerData.button}
					background={introBannerData.background}
				/>

				<nav>
					<BreadCrumb section="Programmes" />
				</nav>

				<div className="content-wrapper">
					<IntroCard 
						title={introData.title}
						subTitle={introData.subTitle}
						description={introData.description}
						link={introData.link}
						image={introData.image}
					/>
				</div>

				{/* NEW: Sector Updates (moved from Home) */}
				<div className="scroll" id="sector-updates"></div>
				<div className="content-wrapper">
					<SectorUpdates />
				</div>

				{/* NEW: Sector Reports (moved from Media & News → Tutuwa and Partners) */}
				<div className="scroll" id="sector-reports"></div>
				{/* <div className="content-wrapper content-wrapper--gray">
					<HighlightCarousel 
						title={partnersData.title}
						description={partnersData.description}
						slides={partnersData.highlights}
					/>
				</div> */}

				{/* Final Reports Section */}
				<div className="scroll" id="reports"></div>
				<div className="content-wrapper content-wrapper--blue">
					<Reports
						title={reportsData.title}
						description={reportsData.description}
						reports={reportsData.reports}
					/>
				</div>
			</div>
		);
	}
}

export default Programmes;
